import './styles/style.scss';
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import header from './blocks/header_block';
import hero from './blocks/hero_block';
import {initBlocks} from './blocks';
import {getHeightOfViewPort} from './scripts/functions/getHeightOfViewPort';
import {generateDataHover} from './scripts/functions/generateDataHover';
import {initModal} from "./scripts/general/custom-modal";
import {scrollToHash} from './scripts/general/scroll-to-hash';
import {activePage} from "./scripts/general/active-page";

const reInvokableFunction = async (container = document) => {
  container.querySelector('header') && await header(container.querySelector('header'));
  container.querySelector('.hero_block') && await hero(container.querySelector('.hero_block'));
  initBlocks(container);
  generateDataHover(container);
  scrollToHash(container);
  getHeightOfViewPort(container);
  activePage(container);
  initModal()

  ScrollTrigger.refresh(false);
};
let loaded = false;

async function onLoad() {
  if (loaded) return; // Ensure it runs only once

  gsap.config({
    nullTargetWarn: false,
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    loaded = true;

    gsap.registerPlugin(ScrollTrigger);
    await reInvokableFunction();

    document.body.classList.add('loaded');
    document.dispatchEvent(new Event('loaded'));

    // Force page to scroll to element if URL has hash
    let currentURL = window.location.href;
    let blockID = currentURL.split('#')[1];

    if (blockID) {
      let block = document.getElementById(blockID);
      if (block) {
        document.body.classList.remove('loaded');
        setTimeout(() => {
          let headerOffset = window.headerSticky ? window.headerSticky : 93;
          window.scrollTo(0, block.getBoundingClientRect().top + window.scrollY - headerOffset);
          document.body.classList.add('loaded');
        }, 400);
      }
    }
  }
}

// Ensure onLoad runs at the correct time
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  onLoad();
} else {
  document.addEventListener('DOMContentLoaded', onLoad);
}

document.onreadystatechange = function () {
  onLoad();
};
